import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function AlertCircle({ color = colors.error['DEFAULT'], ...props }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0375 4.96243 13.5 8 13.5C11.0375 13.5 13.5 11.0375 13.5 8C13.5 4.96243 11.0375 2.5 8 2.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 4.83333C8.27613 4.83333 8.5 5.05719 8.5 5.33333V8.66667C8.5 8.9428 8.27613 9.16667 8 9.16667C7.72387 9.16667 7.5 8.9428 7.5 8.66667V5.33333C7.5 5.05719 7.72387 4.83333 8 4.83333ZM8 11.3333C8.3682 11.3333 8.66667 11.0349 8.66667 10.6667C8.66667 10.2985 8.3682 10 8 10C7.6318 10 7.33333 10.2985 7.33333 10.6667C7.33333 11.0349 7.6318 11.3333 8 11.3333Z"
        fill={color}
      />
    </svg>
  );
}
